import { call, put, takeLatest } from "redux-saga/effects";
import { fetchNavigation } from "../navigationAPI";
import * as UserService from "@container/AdminPanel/features/users/UserService";
import {
  fetchNavigationRequest,
  fetchNavigationSuccess,
  fetchNavigationError,
} from "../../../common/slice/navigation";

function* fetchNavigationSaga() {
  try {
    const response = yield call(fetchNavigation);
    if (response && UserService.isSuccessResponse(response)) {
      const nav = (response.data || []).reduce((r, e) => {
                r[e.old_name] = {
                    "Name": e.name, "Status": e.status,
                    "OldStatus": e.old_status, "Icon": e.icon, "Route": e.route
                };
                return r;
            }, {});
      sessionStorage.setItem('navigation', JSON.stringify(nav));
      yield put(fetchNavigationSuccess(nav));
    } else {
      const errorMsg = UserService.getErrorMessage
        ? UserService.getErrorMessage(response, "Failed to fetch navigation")
        : "Failed to fetch navigation";
      yield put(fetchNavigationError(errorMsg));
    }
  } catch (error) {
    console.error("navigation error:", error);
    yield put(
      fetchNavigationError((error && error.message) || "Failed to fetch navigation")
    );
  }
}

export default [
  takeLatest(fetchNavigationRequest.type, fetchNavigationSaga),
];
